import React, { useContext } from "react";
import { LanguageContext } from "../utils/contexts";

import { ButtonGroup, Button } from "@material-ui/core";
import { IconFlagFR, IconFlagUK } from "material-ui-flags";

const LanguageSwitcher = (props) => {
  const { changeLanguage } = useContext(LanguageContext);

  return (
    <ButtonGroup>
      <Button
        aria-label="switch to french"
        onClick={() => changeLanguage("fr")}
        style={{ border: "none" }}
      >
        <IconFlagFR />
      </Button>
      <Button
        aria-label="switch to english"
        onClick={() => changeLanguage("en")}
        style={{ border: "none" }}
      >
        <IconFlagUK />
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSwitcher;
